"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const Select_1 = __importDefault(require("@mui/material/Select"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const styles_1 = require("./styles");
const StyledSelect = (0, styled_components_1.default)(Select_1.default) `
  ${styles_1.selectStyles}
  ${(props) => props.$placeholder && styles_1.selectPlaceholderStyles}
  ${(props) => props.$open && styles_1.openSelectStyles}
  ${(props) => props.$filled && styles_1.filledSelectStyles}
`;
const StyledMenuItem = (0, styled_components_1.default)(MenuItem_1.default) `
  ${styles_1.menuItemStyles}
`;
const Icon = styled_components_1.default.div `
  position: absolute;
  top: 16px;
  right: 20px;
  cursor: pointer;
`;
const Select = ({ error, helperText, 
// eslint-disable-next-line @typescript-eslint/no-shadow
InputLabelProps, label, OptionProps = {}, optional, options = [], placeholder, value = "", disabled, ...rest }) => {
    const [menuVisible, setMenuVisible] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsx)(StyledSelect, { "$filled": value !== "", "$open": menuVisible, "$placeholder": !value || value === "", IconComponent: () => ((0, jsx_runtime_1.jsx)(Icon, { children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.ArrowDownIconThin, { rotation: menuVisible ? 180 : 0, size: 24 }) })), MenuProps: {
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            },
            elevation: 0,
            transformOrigin: {
                vertical: "top",
                horizontal: "left",
            },
            PaperProps: {
                sx: {
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                },
            },
            MenuListProps: {
                sx: {
                    padding: 0,
                },
            },
        }, disabled: disabled, displayEmpty: true, error: error, onClose: () => setMenuVisible(false), onOpen: () => setMenuVisible(true), renderValue: (val) => options.find((o) => o.value === val)?.label || placeholder, value: value, variant: "outlined", ...rest, children: options.map((option) => ((0, jsx_runtime_1.jsx)(StyledMenuItem, { value: option.value, ...OptionProps, children: option.label }, option.value))) }));
};
exports.default = Select;
//# sourceMappingURL=Select.js.map